// extracted by mini-css-extract-plugin
export default {"invisibleLabelFormItem":"styles_invisibleLabelFormItem__xJnrj"};